import React, { useState } from 'react';
import './startprojectcontent.css'
import coding from '../../../assets/coding.jpeg';
import StartProjectAddRoles from './startprojectaddroles';
import { getLoginId } from '../../Authentication/AuthSvc/authservice';
import SkillsDropdown from '../../SkillsDropdown/skillsdropdown';

const API_URL = process.env.REACT_APP_API_URL;

const StartProjectContent = () => {

  const [isPopupOpen, setisPopupOpen] = useState(false);
  const [roles, setRoles] = useState([]);
  const [projtags, setProjtags] = useState([]);
  const [projectcreated, setProjectCreated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add loading state
  const loginid = getLoginId();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);

    const reader = new FileReader();
    reader.onload = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleAddRole = (event) => {
    event.preventDefault();
    const roleName = event.target.roleName.value;
    const roleDesc = event.target.roleDesc.value;
    const roleExists = roles.some(role => role.name === roleName);

    if (roleExists) {
      window.alert('Role name already exists.');
      return false;
    } else if (roleName && roleDesc) {
      setRoles([...roles, { name: roleName, description: roleDesc }]);
      event.target.roleName.value = '';
      event.target.roleDesc.value = '';
      setisPopupOpen(false);
      return true;
    } else {
      window.alert('Role name or description cannot be empty.');
      return false;
    }
  }

  const openPopup = () => {
    setisPopupOpen(true);
  }

  const closePopup = () => {
    setisPopupOpen(false);
  }

  const handleAddprojtags = (event) => {
    let newTag;
    
    // Check if we're getting an event (from form) or direct value (from dropdown)
    if (event.preventDefault) {
        // It's a form submission event
        event.preventDefault();
        newTag = event.target.projtags.value.trim();
        event.target.projtags.value = ''; // Clear the form input
    } else {
        // It's a direct value from the dropdown
        newTag = event.trim();
    }

    if (newTag && !projtags.includes(newTag)) {
        setProjtags([...projtags, newTag]);
    }
  };


  const handleRemoveRole = (roleName) => {
    setRoles(prevRole => prevRole.filter(role => role.name !== roleName));
  }

  const handleRemoveTag = (tagname) => {
    setProjtags(prevTags => prevTags.filter(projtags => projtags !== tagname));
  }

  const handleCreateProject = async (event) => {
    event.preventDefault();
    
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }
    
    const formData = new FormData();

    formData.append('image', selectedFile);
    formData.append('loginid', loginid);
    formData.append('projtitle', event.target.projtitle.value);
    formData.append('phase', event.target.phase.value);
    formData.append('recruiting', event.target.recruiting.value);
    formData.append('projdesc', event.target.projdesc.value);
    formData.append('roles', JSON.stringify(roles));
    formData.append('projtags', JSON.stringify(projtags));

    if (projtags.length < 1) {
      window.alert("Please add at least one Tag.");
      return;
    }

    if (roles.length < 1) {
      window.alert("Please add at least one Role.");
      return;
    }

    if(!selectedFile){
      window.alert("Please add an image");
      return;
    }

    try {
      // Set loading state to true
      setIsSubmitting(true);
      
      const response = await fetch(`${API_URL}/startproject`, {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        setProjectCreated(true);
        console.log("Project created successfully");
      } else {
        const errorData = await response.json();
        console.log('Error:', errorData.error);
        throw new Error(errorData.error || 'Failed to create project');
      }
    } catch (error) {
      console.log('Error creating project:', error);
      alert(error.message);
    } finally {
      // Reset loading state regardless of success or failure
      setIsSubmitting(false);
    }
  }

  return (
    <div className='startprojectbody'>
      {projectcreated === true ? (
        <div className="createdproj-grid-container">
          <div className="projcreatedcontainer">
            <div className="projcreatedtitle">
              <h2 >Project is created.</h2><span>Click <a href={`myprojects/${loginid}`} style={{ color: "#09CE78" }}>Here</a> to view your projects.</span>
            </div >
          </div>
        </div >
      ) : (
        <div className="startproject-grid-container">
          <div className="startproject-column1">
            <div className="startproject-grid-item startproject-grid-1">
              <form onSubmit={handleCreateProject}>
                <div className='titlecreate'>
                  <h2>Create Project</h2>
                  <button 
                    type="submit" 
                    className='startprojsaveBtn' 
                    disabled={isSubmitting}
                    style={{ 
                      opacity: isSubmitting ? 0.7 : 1,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {isSubmitting ? 'Creating...' : 'Create'}
                  </button>
                </div>
                <hr style={{ marginTop: '0.8rem', marginBottom: '2rem' }} />
                
                {/* Move image upload here for mobile - it will show above project details on small screens */}
                <div className="startproject-grid-item startproject-grid-3 mobile-image-upload">
                  <div className="image-upload-container">
                    <h3>Project Image</h3>
                    <input 
                      type="file" 
                      onChange={handleFileChange} 
                      className="file-input"
                      accept="image/*"
                    />
                    {previewUrl && (
                      <div className="image-preview-container">
                        <img 
                          src={previewUrl} 
                          alt="Preview" 
                          className='startprojectImg'
                        />
                      </div>
                    )}
                  </div>
                </div>
                
                <div classname = 'projectInfo'>
                  <div style={{ width: '100%' }}>
                    <input type="text" name="projtitle" className='projtitleinput' placeholder='Project Title' required />
                    <br /> <br />
                    <b style={{ marginTop: '5rem' }}>Project Phase</b>
                    <select name="phase" id="phase" className='projdropinput' required>
                      <option value="" disabled selected hidden>Phase</option>
                      <option value="Onboarding">Onboarding</option>
                      <option value="Initiation">Initiation</option>
                      <option value="Execution">Execution</option>
                      <option value="Closed">Closed</option>
                    </select>
                    <br /> <br /> 
                    <b style={{ marginTop: '5rem' }}>Recruiting</b>
                    <select name="recruiting" id="recruiting" className='projdropinput' required>
                      <option value="" disabled selected hidden>Recruiting</option>
                      <option value="Open">Open</option>
                      <option value="Closed">Closed</option>
                    </select>
                  </div>
                </div><br />
                <div className='startprojdesc'>
                  <textarea name='projdesc' className='projdesctextarea' placeholder='Project Description' required />
                </div><br />
                <br />
              </form>
            </div>

            <div className="startproject-grid-item startproject-grid-2">
              <h2 className='startgrid-2-title'>Roles<button className='strtaddbtn' onClick={openPopup}><i class="fa-solid fa-plus"></i></button></h2>
              {isPopupOpen && <StartProjectAddRoles onClose={closePopup} handleAddRole={handleAddRole} />}
              <hr style={{ marginBottom: '1rem' }} />
              <div>
                {roles.length > 0 ? (
                  roles.map((role, index) => (
                    <div key={index}>
                      <p style={{ marginBottom: '1rem' }}>{role.name}<button className='myprojsbtn' onClick={() => handleRemoveRole(role.name)}><i class="fa-solid fa-trash"></i></button></p>
                      <ul>
                        <li>{role.description}</li>
                      </ul>
                      <br />
                    </div>
                  ))
                ) : (
                  <div>
                    <p style={{ marginTop: '0.5rem' }}>No Roles Added</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="startproject-column2">
            <div className=" startproject-grid-item startproject-grid-3">
              <span style={{marginRight:'1rem'}}>Image Upload</span><input type="file" onChange={handleFileChange} style={{width:'50%'}}/>
              {previewUrl && <img src={previewUrl} alt="Preview" className='startprojectImg'/>}
            </div>
            <div className="startproject-grid-item startproject-grid-5">
              <h3>Project Tags</h3><br />
              <div>
                <div className="mb-4">
                  <SkillsDropdown 
                    onSelect={handleAddprojtags}
                    placeholder="Add Tag"
                  />
                </div>
                <div className='sprojtags'>
                  {projtags.length > 0 ? (
                    projtags.map((tag, index) => (
                      <div key={index}>
                        <a className='sprojtag'>
                          {tag}
                          <button 
                            onClick={() => handleRemoveTag(tag)} 
                            className='projtagsdelete'
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </button>
                        </a>
                      </div>
                    ))
                  ) : (
                    <div>
                      <p>No Tags Added</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div >
  );
};

export default StartProjectContent;
